<template>
  <div class="modal fade confirm" :class="{ 'is-open': open }">
    <div class="modal-dialog" style="width: 950px">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">無法進行保單健檢</h3>
        </div>
        <div class="modal-body">
          <div class="d-flex" style="height: 600px">
            <div
              class="px-2"
              style="border-right: 1px rgb(179, 179, 179) solid"
            >
              <img
                class="permissions-img"
                :src="`${BaseUrl}assets/common/check_permissions.png`"
              />
            </div>
            <div class="d-flex flex-column flex-shrink-1 px-2 py-2 text-style">
              <span
                >Sorry!經查詢<i class="red-text">
                  <span v-for="(item, index) in memberName" :key="item.id">
                    {{memberName.length !== index + 1 ? item + " 、" : item}}
                  </span>
                  為公司同仁</i
                >，您不能幫同仁做保單健檢喔!</span
              >
              <span class="mt-5" style="margin-bottom: auto"
                >如您有需要，請被做保單健檢之公司同仁本人填寫<i>『簡覆表』</i>至數位支援科申請開放權限。</span
              >
              <span>
                <div class="text-right">
                  <a @click="$emit('close')" class="btn btn-primary"> 確定 </a>
                </div></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CheckCompanyColleagueProp",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    memberName: {
      type: Array,
      default: undefined,
    },
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
i {
  font-style: normal;
}
.permissions-img {
  width: 600px;
  height: 100%;
}
.red-text {
  color: red;
}
.text-style {
  font-size: 24px;
  font-weight: bold;
  text-align: justify;
}
</style>